<template>
    <div>
        <h1 style="font-size: 24px; color: black;">公司管理</h1>
        <el-card class="form-container" shadow="never">
            <el-card class="form-container" shadow="never">
                <el-form :inline="true" :model="queryData" size="small" label-width="140px">
                    <el-form-item label="名称：">
                        <el-input v-model="queryData.companyName" style="width: 200px" clearable placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="税号：">
                        <el-input v-model="queryData.taxIdNumber" style="width: 200px" clearable placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="银行账户：">
                        <el-input v-model="queryData.accountNumber" style="width: 200px" clearable placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label=" " class="sub-sub21" >
                        <el-button type="primary" @click="query">查询</el-button>
                        <el-button class="sub-sub" type="primary" @click="showDetails('新增应用')">新增</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </el-card>
        <h1>
            <el-table :data="companyList"
                      border
                      :fit="true">
                <el-table-column label="公司编号" prop="id" align="center"></el-table-column>
                <el-table-column label="公司名称" prop="companyName" align="center"></el-table-column>
                <el-table-column label="公司简称" prop="abbreviation" align="center" ></el-table-column>
                <el-table-column label="公司税号" prop="taxIdNumber" align="center" ></el-table-column>
                <el-table-column label="税率" prop="taxLv" align="center" ></el-table-column>
                <el-table-column label="公司电话" prop="phoneNumber" align="center" ></el-table-column>
                <el-table-column label="公司地址" prop="address" align="center" ></el-table-column>
                <el-table-column label="公司开户行" prop="accountWithBank" align="center"></el-table-column>
                <el-table-column label="公司银行账号" prop="accountNumber" align="center"></el-table-column>
                <el-table-column label="联系人" prop="contact" align="center"></el-table-column>
                <el-table-column label="联系人电话" prop="contactPhone" align="center"></el-table-column>
                <el-table-column label="联系人地址" prop="contactAddress" align="center"></el-table-column>
                <el-table-column label="创建时间"  align="center">
                    <template slot-scope="scope">
                        {{formatDate(scope.row.createDt,"yyyy-MM-DD HH:mm:ss")}}
                    </template>
                </el-table-column>
                <el-table-column label="操作时间"  align="center">
                    <template slot-scope="scope">
                        {{formatDate(scope.row.updateDt,"yyyy-MM-DD HH:mm:ss")}}
                    </template>
                    </el-table-column>
                <el-table-column label="操作" prop="" align="center">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="primary" @click="showDetails('编辑应用',scope.row)">编辑</el-button>
                        <el-button plain size="mini" type="danger" @click="remove('删除应用',scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </h1>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="1200px">
            <el-form :model="addCompanyForm">
                <el-form-item label="公司名称 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addCompanyForm.companyName" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="公司简称 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addCompanyForm.abbreviation" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="公司税号 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addCompanyForm.taxIdNumber" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="税率 :" :label-width="labelWidth">
                    <el-input-number :precision="4" :step="0.01" :max="10"  v-model="addCompanyForm.taxLv"></el-input-number>
                </el-form-item>
                <el-form-item label="公司电话 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addCompanyForm.phoneNumber" ></el-input>
                </el-form-item>
                <el-form-item label="公司地址 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addCompanyForm.address" ></el-input>
                </el-form-item>
                <el-form-item label="公司开户行 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addCompanyForm.accountWithBank" ></el-input>
                </el-form-item>
                <el-form-item label="公司银行账号 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addCompanyForm.accountNumber" ></el-input>
                </el-form-item>
                <el-form-item label="联系人 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addCompanyForm.contact" ></el-input>
                </el-form-item>
                <el-form-item label="联系人电话 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addCompanyForm.contactPhone" ></el-input>
                </el-form-item>
                <el-form-item label="联系人地址 :" :label-width="labelWidth">
                    <el-input  type="text" v-model="addCompanyForm.contactAddress" ></el-input>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirmForm" >提 交</el-button>
                    <el-button type="info" @click="dialogVisible=false">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
        </el-pagination>
    </div>
</template>

<script>
    import {
        searchCompany,
        saveCompany,
        deleteCompany
    } from "@/http/settingApi";
    import utils from '@/utils'
    export default {
        name: "CompanyManage",
        data(){
            return{
                dialogVisible:false,
                dialogTitle:'',
                companyList:[],
                labelWidth: '110px',
                addCompanyForm: {
                    id: 0,
                    companyName: '',
                    abbreviation:'',
                    taxIdNumber:'',
                    taxLv:0.0,
                    phoneNumber:'',
                    address:'',
                    accountWithBank:'',
                    accountNumber:'',
                    contact:'',
                    contactPhone:'',
                    contactAddress:''
                },
                queryData:{
                    taxIdNumber:'',
                    companyName:'',
                    accountNumber:''
                },
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
            }
        },
        methods:{
            formatDate: function(row, column) {
                return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD HH:mm:ss")
            },
            showDetails(title,data){
                if (data){
                    this.addCompanyForm= {
                        id: data.id,
                        companyName: data.companyName,
                        abbreviation:data.abbreviation,
                        taxIdNumber:data.taxIdNumber,
                        taxLv:data.taxLv,
                        phoneNumber:data.phoneNumber,
                        address:data.address,
                        accountWithBank:data.accountWithBank,
                        accountNumber:data.accountNumber,
                        contact:data.contact,
                        contactPhone:data.contactPhone,
                        contactAddress:data.contactAddress
                    }
                }else {
                    this.addCompanyForm= {
                        id: 0,
                        companyName: '',
                        abbreviation:'',
                        taxIdNumber:'',
                        taxLv:0.0,
                        phoneNumber:'',
                        address:'',
                        accountWithBank:'',
                        accountNumber:'',
                        contact:'',
                        contactPhone:'',
                        contactAddress:''
                    }
                }
                this.dialogTitle  = title;
                this.dialogVisible = true;
            },
            remove(id){
                this.$confirm('此操作将永久删除公司信息, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteCompany(id).then(resp=> {
                        if (resp.data.status === 0) {
                            this.query();
                        }
                    });
                }).catch(() => {
                })
            },
            confirmForm(){
                let _message = '';
                if(this.addCompanyForm.companyName===''){
                    _message = '请输入公司名称'
                }else if (this.addCompanyForm.taxIdNumber===''){
                    _message = '请输入公司税号'
                }else if (this.addCompanyForm.accountNumber===''){
                    _message = '请输入公司银行账号'
                }else if (this.addCompanyForm.accountWithBank===''){
                    _message = '请输入公司开户行'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveCompany(this.addCompanyForm).then(resp => {
                    if (resp.data.status === 0 ){
                        this.query();
                        this.dialogVisible = false;
                    }
                });
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.query();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.query();
            },
            query(){
                this.queryData.size = this.page.size;
                this.queryData.page = this.page.page;
                searchCompany(this.queryData).then(resp => {
                    this.companyList = resp.data.info.content;
                    this.page.totalElements = resp.data.info.totalElements
                })
            },

        },
        created() {
            this.query();
        }
    }
</script>

<style scoped>
    .sub-sub21{ position: relative; right: 100px}
</style>